import React, {useState, useRef, useEffect} from 'react'
import { Form } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'

function SearchBox() {
    const [keyword, setKeyword] = useState('')
    const [open, setOpen] = useState(false)
    const inputRef = useRef(null)
    const navigate = useNavigate()
    const location = useLocation()
    const submitHandler = (e) => {
        e.preventDefault()

        if (keyword){
            navigate(`/?keyword=${encodeURIComponent(keyword)}&page=1`)
        } else{
            navigate(location.pathname)
        }
        setOpen(false)
    }
    useEffect(() => {
        if (open && inputRef.current){
            inputRef.current.focus()
        }
    }, [open])
  return (
    <div className={`ws-search-inline ${open ? 'open' : ''}`}>
      <Form
        onSubmit={submitHandler}
        className="ws-search-form-inline"
        onClick={() => { if(!open){ setOpen(true) } }}
        onBlur={(e) => {
          // close when focus leaves the form
          if (!e.currentTarget.contains(document.activeElement)) {
            setOpen(false)
          }
        }}
      >
        <i className="fas fa-search ws-search-ic"></i>
        <Form.Control
          ref={inputRef}
          type='text'
          name='q'
          placeholder='Search products'
          onChange={(e) => setKeyword(e.target.value)}
          className='ws-search-input'
        />
      </Form>
    </div>
  )
}

export default SearchBox